/**
 * @fileoverview GET handler for the "/engagement/preset_landing_page_templates_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetLandingPageTemplatesData } from "./constants";
import type { EngagementPresetLandingPageTemplatesDataResult } from "./types";
import { isEngagementPresetLandingPageTemplatesDataResult } from "./validators";

export const getDataTableEngagementPresetLandingPageTemplatesData = reactQueryTableFetcherAdapter(
  engagementPresetLandingPageTemplatesData,
  (signal: AbortSignal): Promise<EngagementPresetLandingPageTemplatesDataResult> => {
    return fetch("/engagement/preset_landing_page_templates_data", "GET", {}, { signal });
  },
  isEngagementPresetLandingPageTemplatesDataResult
);
